// extracted by mini-css-extract-plugin
export var eyebrow = "_dv-3";
export var heroImage = "_dv-4";
export var main = "_dv-2";
export var modal = "_dv-0";
export var shell = "_dv-1";